export default __webpack_public_path__ + "static/media/olives.65b51b01.png";